import { ReactElement, Suspense, useCallback } from "react";
import { UiDynamicRenderer as UiDynamicRendererUiModules } from "@rotorstudios/fe-ui";

import useGlobalParams from "../Data/useGlobalParams";
import Components from "./components";
import ViewportAwareRenderer from "./ViewportAwareRenderer";
import {
  UI_MODULE_MENU_STICKY,
  UI_ORGANISM_DEALERSHIP_TILES,
  UI_MOLECULE_CARD_DEALER,
} from "../Data/static";

type UiDynamicRendererProps = {
  data: any;
};

export const UiDynamicRenderer = ({ data }: UiDynamicRendererProps): ReactElement => {
  const { injectGlobalParams } = useGlobalParams();

  const getComponent = useCallback(
    (component: any) => {
      if (!component.originalProps) {
        component.originalProps = component.props;
      }

      component.props = {
        ...injectGlobalParams({ ...(component.originalProps || component.props) }),
        cmsMetadata: component.meta,
      };

      if (Object.keys(Components).includes(component.type)) {
        // @ts-ignore
        const ComponentType = Components[component.type];
        return (
          <Suspense fallback={<></>} key={component.id}>
            <ComponentType key={component.id} {...component.props} />
          </Suspense>
        );
      }

      return (
        component.id && (
          <UiDynamicRendererUiModules key={component.id} data={[component]} />
        )
      );
    },
    [injectGlobalParams],
  );

  const SKIP_FROM_VIEWPORT_AWARE_RENDERER = new Set([
    UI_MODULE_MENU_STICKY,
    UI_ORGANISM_DEALERSHIP_TILES,
    UI_MOLECULE_CARD_DEALER,
  ]);

  return data?.map((component: any) => {
    if (SKIP_FROM_VIEWPORT_AWARE_RENDERER.has(component.type)) {
      return getComponent(component);
    }

    return (
      <ViewportAwareRenderer
        key={component.id}
        component={component}
        getComponent={getComponent}
      />
    );
  });
};
